import React from "react";
import { graphql } from "gatsby";
import { Helmet } from "react-helmet";
import Navbar from "../components/navigation/Navbar";
import favicon from "../assets/images/favicon.ico";
import "../assets/styles/guides.scss";

export default function Template({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { markdownRemark } = data; // data.markdownRemark holds your post data
  const { frontmatter, html } = markdownRemark;
  return (
    <div>
      <Helmet bodyAttributes={{ class: "has-navbar-fixed-top" }}>
        <meta charSet="utf-8" />
        <meta name="description" content="Maplestory M guides and resources" />
        <meta
          name="keywords"
          content="maplestorym, maplestory m, msm, guides, tutorials, msm help, maplestorym resources"
        />
        <title>Maplestory M Resources</title>
        <description>
          A place for up-to-date maplestory m resources and content!
        </description>
        <link rel="canonical" href="https://maplemresources.com" />
        <link rel="icon" href={favicon} />
      </Helmet>
      <Navbar />
      <main className="guide">
        <div className="content">
          <h1>{frontmatter.title}</h1>
          <em>Last Updated: {frontmatter.date}</em>
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </main>
    </div>
  );
}

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
  }
`;
